import { render, staticRenderFns } from "./PerformDash.vue?vue&type=template&id=4832b6f8&scoped=true&"
import script from "./PerformDash.vue?vue&type=script&lang=js&"
export * from "./PerformDash.vue?vue&type=script&lang=js&"
import style0 from "./PerformDash.vue?vue&type=style&index=0&id=4832b6f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4832b6f8",
  null
  
)

export default component.exports